
import {
    GET_ALLOWED_BOOKING_OPERATORS_URL,
    GET_SCHEDULES_WITH_SHARING_FLAGS_URL,
    UPDATE_SCHEDULE_SHARING_FLAGS_URL,
    GET_SHARING_AGENT_ACTIONS_URL
} from "./../utils/api-url";
import { postCall } from "../utils/network.util";


export const getAllowedBookingOperators=(onSuccess=()=>{},onFailure=()=>{})=>{
  var fetched = postCall(GET_ALLOWED_BOOKING_OPERATORS_URL, {operatorCode:global.operatorCode});
  fetched.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to get allowed booking operators");
    })
}

export const getSchedulesWithSharingFlags=(onSuccess=()=>{},onFailure=()=>{})=>{
  var fetched = postCall(GET_SCHEDULES_WITH_SHARING_FLAGS_URL, {operatorCode:global.operatorCode});
  fetched.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to get schedules");
    })
}

// owner: operator code string, or {ownerOperatorCode} / {ownerTravelsId}
export const getSharingAgentActions=(owner,onSuccess=()=>{},onFailure=()=>{})=>{
  let ownerInfo = typeof owner === 'object' && owner !== null ? owner : {ownerOperatorCode:owner};
  var fetched = postCall(GET_SHARING_AGENT_ACTIONS_URL, {
    operatorCode:global.operatorCode,
    ...ownerInfo
  });
  fetched.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to get sharing agent actions");
    })
}

export const updateScheduleSharingFlags=(info,onSuccess=()=>{},onFailure=()=>{})=>{
  var updated = postCall(UPDATE_SCHEDULE_SHARING_FLAGS_URL, {data:info});
  updated.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to update schedule sharing");
    })
}
